import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  border-right: ${({ theme }) => theme.semantic.container.border};
  transition: width 0.2s ease;
  overflow: hidden;
  flex-shrink: 0;
`;

export const CollapseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f5f7;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  z-index: 10;
  color: #5c6f82;

  &:hover {
    background-color: #e8ebed;
  }

  svg {
    margin: 0;
    font-size: 14px;
  }
`;

export const Header = styled.div`
  padding: 16px 60px 16px 20px; /* Add right padding to avoid overlap with collapse button */
  border-bottom: 1px solid #e8ecf1;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1a2332;
  margin: 0;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #5c6f82;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const LengthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: 100%;
`;

export const LengthOption = styled.button<{ $active: boolean }>`
  padding: 10px;
  border: 1px solid ${({ $active }) => ($active ? "#0066cc" : "#e1e8ef")};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: ${({ $active }) => ($active ? "#e3f2fd" : "#ffffff")};
  color: ${({ $active }) => ($active ? "#0066cc" : "#5c6f82")};

  &:hover {
    background-color: ${({ $active }) => ($active ? "#e3f2fd" : "#f3f5f7")};
    border-color: ${({ $active }) => ($active ? "#0066cc" : "#c5d0dd")};
  }

  &:active {
    transform: scale(0.96);
  }

  svg {
    font-size: 12px;
  }
`;

export const CustomWeeksInput = styled.input<{ $error?: boolean }>`
  padding: 10px;
  border: 2px solid ${({ $error }) => ($error ? "#dc2626" : "#0066cc")};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  background-color: ${({ $error }) => ($error ? "#fef2f2" : "#ffffff")};
  color: ${({ $error }) => ($error ? "#dc2626" : "#1a2332")};
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &::placeholder {
    color: ${({ $error }) => ($error ? "#fca5a5" : "#8391a1")};
  }

  &:focus {
    border-color: ${({ $error }) => ($error ? "#dc2626" : "#0066cc")};
    box-shadow: ${({ $error }) => ($error ? "0 0 0 3px rgba(220, 38, 38, 0.1)" : "0 0 0 3px rgba(0, 102, 204, 0.1)")};
  }

  /* Remove spinner arrows */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }
  appearance: textfield;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e8ecf1;
  margin: 20px 0;
`;

export const TemplatesContent = styled.div`
  margin-top: 12px;
`;

export const FilterSection = styled.div`
  margin-bottom: 12px;
`;

export const TemplatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 280px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;

    &:hover {
      background: #a0aec0;
    }
  }
`;

export const CompactTemplateItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background-color: #ffffff;
  border: ${({ theme }) => theme.semantic.container.border};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: #f0f7ff;
    border-color: #0066cc;
    box-shadow: 0 2px 6px rgba(0, 102, 204, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const TemplateIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TemplateInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const TemplateName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TemplateType = styled.span`
  font-size: 9px;
  color: #0066cc;
  background-color: #e3f2fd;
  padding: 3px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  align-self: flex-start;
`;

export const EmptyState = styled.div`
  padding: 20px 12px;
  text-align: center;
  font-size: 13px;
  color: #8391a1;
`;

export const DurationWeeksToggle = styled.div`
  margin-bottom: 16px;
`;

export const ToggleTrack = styled.div`
  position: relative;
  display: flex;
  background-color: #f3f5f7;
  border-radius: 8px;
  padding: 3px;
  height: 36px;
`;

export const ToggleOption = styled.button<{ $active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 550;
  color: ${({ $active }) => ($active ? "#0066cc" : "#5c6f82")};
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 2;
  transition: color 0.3s ease;
  position: relative;

  svg {
    font-size: 12px;
  }

  &:hover {
    color: ${({ $active }) => ($active ? "#0066cc" : "#1a2332")};
  }
`;

export const ToggleSlider = styled.div<{ $position: "left" | "right" }>`
  position: absolute;
  top: 3px;
  left: ${({ $position }) => ($position === "left" ? "3px" : "calc(50%)")};
  width: calc(50% - 3px);
  height: calc(100% - 6px);
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
`;

export const HealthFormWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  background-color: #ffe6e6ff;
  border: 1px solid #ff4d4dff;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #8b0000ff;

  svg {
    color: #ff0000ff;
    font-size: 14px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  span {
    flex: 1;
  }
`;
